<template>
    <BaseButton
        v-if="!tiny"
        class="social-auth-btn w-100 pa-2"
        @click="onClick"
        type="submit"
        :style="`background-color: ${color} !important`"
        ><img class="login-icon" :src="img" />
        {{ label }}
    </BaseButton>
    <div
        class="d-flex align-items-center pointer clickable"
        style="border-radius:16px;border:1px solid #ddd;position:relative;height:36px;"
        @click="onClick"
        v-else
    >
        <div
            :style="
                `border-radius:50%;background-color:${color};width:36px;height:36px;padding:8px;position:absolute;left:-2px;top:-1px;bottom:0;`
            "
        >
            <img
                :src="img"
                style="object-fit:scale-down;width:100%;height:100%;"
            />
        </div>
        <h6 class="caption mute mb-0 text-center ml-5" style="font-size:12px">
            {{ label }}
        </h6>
    </div>
</template>

<script>
export default {
    name: 'SocialAuthBtn',
    props: {
        img: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
        tiny: Boolean,
    },
    methods: {
        onClick() {
            this.$emit('click');
        },
    },
};
</script>

<style scoped>
.social-auth-btn {
    box-sizing: border-box;
    color: white;
    border-radius: 5px;
    border: none;

    white-space: nowrap;
    background-color: #00dd6c !important;
}

.social-auth-btn:hover {
    color: white;
}

.login-icon {
    margin-right: 30px;
    width: 25px;
    height: 25px;
}
</style>
